import { Button, Col, Form } from 'react-bootstrap';
import React from 'react';
import { Auth } from 'aws-amplify';
import { useForm } from 'react-hook-form';

interface ForgotPasswordProps {
  changeToLogin: Function;
  username?: string;
  hideSignInModal: Function;
}

function NewPassword({ changeToLogin, username, hideSignInModal }: ForgotPasswordProps) {
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm();

  async function confirmNewPassword(data: any) {
    try {
      await Auth.forgotPasswordSubmit(data.username, data.code, data.new_password);
      changeToLogin(username);
    } catch (err) {
      console.log('error resending code: ', err);
    }
  }

  return (
    <Col xs={12} className="gray-background-sign single-page-modal">
      <div>
        <button className="close" onClick={() => hideSignInModal()}>
          &times;
        </button>
      </div>
      <div className="sign-up-header">Confirm New Password</div>
      <div>
        <Form onSubmit={handleSubmit(confirmNewPassword)}>
          <Form.Row>
            <Form.Group as={Col} controlId="formEmail">
              <Form.Label>Email</Form.Label>
              <Form.Control
                value={username}
                type="email"
                placeholder="Your email address"
                {...register('username', {
                  required: 'Email required'
                })}
              />
              {errors.email && (
                <Form.Text id="emailHelpBlock" muted>
                  {errors.email.message || 'Required'}
                </Form.Text>
              )}
            </Form.Group>
          </Form.Row>

          <Form.Row>
            <Form.Group as={Col} controlId="formPassword">
              <Form.Label>Code</Form.Label>
              <Form.Control type="code" placeholder="Password" {...register('code')} required />
            </Form.Group>
          </Form.Row>

          <Form.Row>
            <Form.Group as={Col} controlId="formPassword">
              <Form.Label>Password</Form.Label>
              <Form.Control type="password" placeholder="Password" {...register('new_password')} required />
            </Form.Group>
          </Form.Row>

          <Form.Row>
            <Form.Group as={Col} controlId="formPhone">
              <Form.Label>Confirm Password</Form.Label>
              <Form.Control type="password" placeholder="ConfirmPassword" required />
            </Form.Group>
          </Form.Row>

          <Form.Row className="py-3 m-0">
            <Button variant="dark" type="submit" className="create-account">
              Confirm
            </Button>
          </Form.Row>

          <Form.Row className="center-content">
            <Form.Text id="log-in-link">
              Remember your password?{' '}
              <span onClick={() => changeToLogin()} className="underline pointer">
                Log In
              </span>
            </Form.Text>
          </Form.Row>
        </Form>
      </div>
    </Col>
  );
}

export default NewPassword;
